<mat-form-field appearance="fill" [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip" matTooltipPosition="above"
  matTooltipClass="sbm-tooltip">

  <mat-label>
    <app-required *ngIf="isRequired()"></app-required> {{label}}
  </mat-label>

  <mat-select [formControl]="control" (ngModelChange)="emitChange($event)" [multiple]="multiple" [disabled]="disabled">
    <mat-option *ngIf="!multiple&&defaultOption">Select {{label}}</mat-option>
    <mat-option *ngFor="let item of options" [value]="valueKey? item[valueKey]:item" [disabled]="item.disabled">
      {{optionKey? item[optionKey]: item}}
    </mat-option>
  </mat-select>

  <ng-container *ngIf="control && control.invalid" ngProjectAs="mat-error">
    <mat-error *ngIf="control.hasError('required')">
      {{label}} is <strong>required</strong>.
    </mat-error>
  </ng-container>
  <mat-hint *ngIf="hint">{{hint}}</mat-hint>
</mat-form-field>